import { MobiSimRegistrationImpl } from "features/mobiSimRegistration/data/MobiSimRegistrationImpl";
import { IMobiSimRegistrationRepository } from "features/mobiSimRegistration/domain/repositories/IMobiSimRegistrationRepository";
import { MobiSimRegistrationUseCase } from "features/mobiSimRegistration/domain/useCases/MobiSimRegistrationUseCase";
import { MobiSimRegistrationViewModel } from "features/mobiSimRegistration/presentation/viewModel/MobiSimRegistrationViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class MobiSimRegistrationInjection extends InjectionModule {
  private static readonly mobiSimRegistrationRepositoryToken = Symbol(
    "IMobiSimRegistrationRepository",
  );
  private static readonly mobiSimRegistrationViewModelToken = Symbol(
    "MobiSimRegistrationViewModel",
  );
  private static readonly mobiSimRegistrationUseCaseToken = Symbol(
    "MobiSimRegistrationUseCase",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.mobiSimRegistrationRepositoryToken,
      useClass: MobiSimRegistrationImpl,
    },
    {
      scope: "otherRepo",
      token: this.mobiSimRegistrationUseCaseToken,
      useClass: MobiSimRegistrationUseCase,
    },
    {
      scope: "viewModel",
      token: this.mobiSimRegistrationViewModelToken,
      useClass: MobiSimRegistrationViewModel,
    },
  ];

  static getMobiSimRegistrationRepo(): IMobiSimRegistrationRepository {
    return this.resolve(this.mobiSimRegistrationRepositoryToken);
  }

  static getMobiSimRegistrationUseCase(): MobiSimRegistrationUseCase {
    return this.resolve(this.mobiSimRegistrationUseCaseToken);
  }
}
